import api from "./api";
import StorageService from "./StorageService";

const ProjectTeamService = {
  getAll: async (page = 1, limit = 20, search = "", projectId = "", employeeId = null, roleId = null, companyId = null) => {
    const login = StorageService.loginData();
    const activeCompany = StorageService.activeCompany();
    const res = await api.get("/projectTeam/getAll", {
      params: {
        page,
        limit,
        search,
        projectId: projectId || null,
        employeeId: employeeId || login?.employeeId,
        roleId: roleId || login?.roleId,
        companyId: companyId || activeCompany?.companyId,
      },
    });

    return res.data;
  },

  getByProjectId: async (projectId, includeExpired = false, targetDate = null) => {
    const params = { includeExpired };
    if (targetDate) {
      params.targetDate = targetDate;
    }
    const res = await api.get(`/projectTeam/getByProjectId/${projectId}`, {
      params,
    });
    return res.data.data;
  },

  getById: async (id) => {
    const res = await api.get(`/projectTeam/getById/${id}`);
    return res.data.data;
  },

  create: async (data) => {
    const res = await api.post("/projectTeam/save", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/projectTeam/update/${id}`, data);
    return res.data;
  },

  toggleStatus: async (id) => {
    const res = await api.put(`/projectTeam/status/${id}`);
    return res.data;
  },

  relieve: async (id, endDate = null) => {
    const res = await api.patch(`/projectTeam/relieve/${id}`, { endDate });
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/projectTeam/${id}`);
    return res.data;
  },

  search: async ({ companyId, employeeId, projectId }) => {
    const res = await api.get("/projectTeam/search", {
      params: {
        companyId,                 // REQUIRED
        employeeId: employeeId || null,
        projectId: projectId || null,
      },
    });

    return res.data.data;
  },
};

export default ProjectTeamService;
